<template>
  <div>
    <v-navigation-drawer v-model="nav" app temporary>
      <v-list dense v-for="(j, index1) in overAllNav" :key="index1">
        <v-list-item
          v-for="(i, index) in j"
          :key="index"
          link
          :to="i.link"
          replace
        >
          <v-list-item-icon>
            <v-icon color="primary1">{{ i.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ i.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="primary1" dark>
      <v-app-bar-nav-icon @click="nav = !nav"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <h1 class="overline text-center">JET WINGS</h1>
      <v-spacer></v-spacer>
      <v-btn icon @click="logout">
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      nav: false,
      overAllNav: [
        [
          {
            title: "DASHBOARD",
            icon: "mdi-view-dashboard",
            link: "/DASHBOARD",
          },
          {
            title: "ALL BILL(s)",
            icon: "mdi-printer",
            link: "/BILL",
          },
          {
            title: "SALES ORDER",
            icon: "mdi-printer-pos",
            link: "/SALES_ORDER",
          },
          {
            title: "PURCHASE ORDER",
            icon: "mdi-cart-arrow-down",
            link: "/PURCHASE_ORDER",
          },
          {
            title: "STORE ROOM",
            icon: "mdi-store",
            link: "/STOREROOM",
          },
        ],
        [
          {
            title: "PRODUCTS",
            icon: "mdi-sitemap",
            link: "/PRODUCTS",
          },
          {
            title: "CATEGORY",
            icon: "mdi-shape",
            link: "/CATEGORY",
          },
          {
            title: "VENDORS",
            icon: "mdi-wallet-membership",
            link: "/VENDORS",
          },
        ],

        // [
        // {
        //   title: "SHOP",
        //   icon: "mdi-hand-heart",
        //   link: "/STORE",
        // },
        // ],
        // [
        //   {
        //     title: "HOLE SALE",
        //     icon: "mdi-store-outline",
        //     link: "/HOLESALE"
        //   },
        //   {
        //     title: "CUSTOMER",
        //     icon: "mdi-account-heart",
        //     link: "/CUSTOMER"
        //   }
        // ],
        // [
        //   {
        //     title: "REPORT",
        //     icon: "mdi-file-chart",
        //     link: "/REPORT"
        //   },
        //   {
        //     title: "RETURNS",
        //     icon: "mdi-clipboard-arrow-down-outline",
        //     link: "/RETURNS"
        //   }
        // ],
        // [
        // [
        //   {
        //     title: "ONLINE",
        //     icon: "mdi-earth",
        //     link: "/ONLINE",
        //   },
        //   {
        //     title: "ONLINE SLIDER",
        //     icon: "mdi-gesture-swipe",
        //     link: "/ONLINE_SLIDER",
        //   },
        //   {
        //     title: "ONLINE CATEGORY",
        //     icon: "mdi-shape",
        //     link: "/ONLINE_CATEGORY",
        //   },
        //   {
        //     title: "ONLINE ITEMS",
        //     icon: "mdi-food-variant",
        //     link: "/ONLINE_ITEMS",
        //   },
        //   {
        //     title: "ONLINE ORDERS",
        //     icon: "mdi-bookshelf",
        //     link: "/ONLINE_ORDERS",
        //   },
        // ],
        [
          {
            title: "PROFILE",
            icon: "mdi-account",
            link: "/PROFILE",
          },
          {
            title: "CREATE USER",
            icon: "mdi-account-plus",
            link: "/NEWUSER",
          },
          {
            title: "HELP",
            icon: "mdi-help",
            link: "/HELP",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters(["LOGGEDIN"]),
  },
  methods: {
    ...mapActions(["LOGOUT"]),
    logout() {
      this.$store.commit("SET_LOADING", true);
      this.LOGOUT().then(() => {
        this.$router.replace("/");
        this.$store.commit("SET_LOADING", false);
      });
    },
  },
};
</script>

<style></style>
